import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography, Box, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function NotFound() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  return (
    <Box textAlign="center">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Page Not Found</title>
        <meta name="description" content="The page you requested could not be found." />
        <meta property="og:title" content="Page Not Found" />
        <meta property="og:description" content="The page you are looking for does not exist." />
        <meta property="og:image" content="/assets/visuals/re-profile-blue-ai-hud.webp" />
      </Helmet>
      <Typography variant="h4" component="h1" gutterBottom color="white">
        Page Not Found
      </Typography>
      <Typography gutterBottom color="white">
        The page you're looking for does not exist.
      </Typography>
      <Button variant="contained" color="secondary" component={Link} to="/">
        Back to Home
      </Button>
    </Box>
  );
}
